export default __webpack_public_path__ + "static/media/met-before-after-submitted-mobile-bg.3c58d862.png";